<template>
  <div class="trace-check-in-log-container">
    <div>
      <el-button
        size="small"
        class="glo_bgcMainColor"
        @click="showAddDia"
        :disabled="!waybillNumber"
        v-permission="'admin:waibill:zonghechaxun:trace:add'"
        >新建跟踪</el-button
      >
    </div>
    <el-table :data="logs" height="100%">
      <el-table-column
        type="index"
        :align="align"
        width="50"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="number"
        :align="align"
        width="180"
        label="客服跟踪单号"
      ></el-table-column>
      <el-table-column
        prop="content"
        :align="align"
        width="180"
        label="内容描述"
      ></el-table-column>
      <el-table-column
        prop="remarks"
        :align="align"
        width="100"
        label="备注"
      ></el-table-column>
      <el-table-column
        prop="isShowShow"
        :align="align"
        width="100"
        label="显示在运单轨迹"
      >
      </el-table-column>
      <el-table-column
        prop="operationTime"
        :align="align"
        width="180"
        label="发生时间"
      ></el-table-column>
      <el-table-column
        prop="createUserName"
        :align="align"
        label="创建人"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        :align="align"
        width="180"
        label="创建时间"
      ></el-table-column>
    </el-table>
    <!-- <el-pagination layout="prev, pager, next, total" :total="1000">
    </el-pagination> -->
    <!-- 跟踪客服录入 -->
    <myDialog
      diaWidth="900px"
      dialogTitle="客服跟踪"
      :isShowDialog="isShowDialogTraceCheckIn"
      @handleCloseDia="isShowDialogTraceCheckIn = false"
      @diaCancelBtn="isShowDialogTraceCheckIn = false"
      @diaConfirmBtn="diaConfirmTraceCheckIn"
    >
      <div class="glo_dialogForm1">
        <el-form
          class="diaForm"
          ref="dialogFormRef"
          label-width="100px"
          :model="addReqs"
        >
          <el-form-item label="关联显示单据:" style="width: 100%">
            <el-input readonly v-model="addReqs.documentNumber"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="客服跟踪单号:" style="width: 100%">
                <el-input readonly v-model="addReqs.number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发生时间:" style="width: 100%">
                <el-date-picker
                  type="datetime"
                  value-format="yyyy-MM-dd"
                  v-model="addReqs.operationTime"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="" style="width: 100%">
            <el-checkbox
              v-model="addReqs.isShow"
              :true-label="1"
              :false-label="0"
              >显示在运单轨迹</el-checkbox
            >
          </el-form-item>
          <el-form-item label="描述内容：" style="width: 100%">
            <el-input
              v-model="addReqs.content"
              type="textarea"
              rows="3"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片：">
            <my-image-upload
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="9"
            ></my-image-upload>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>

<script>
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import MyImageUpload from "@/components/MyImageUpload.vue";
export default {
  props: {
    waybillSplitId: {},
    waybillNumber: {},
    waybillSplitNumber:{}
  },
  components: {
    myDialog,
    uploadimgs,
    MyImageUpload,
  },
  data() {
    return {
      align: "center",
      logs: [],
      isShowDialogTraceCheckIn: false,
      fileNameLists: [],
      activeName: "客服跟踪",
      addReqs: {
        operationTime: "",
        isShow: 0,
        content: "",
        remarks: "",
        documentStatus: "bill_tms_waybill_split_v3.document_status",
        documentNumber: this.waybillNumber,
        fileIds: [],
      },
    };
  },
  watch: {
    waybillSplitNumber: {
      handler(val) {
        if (!val) {
          this.addReqs.documentNumber = "";
          return;
        }
        this.addReqs.documentNumber = this.waybillNumber;
        this.getData();
      },
    },
  },
  mounted(){
    if(!this.waybillSplitNumber){
      return
    }
    this.getData()
  },
  methods: {
    async getData() {
      //  客服跟踪
      let formData = {
        documentNumber: this.waybillSplitNumber,
        documentStatus: "bill_tms_waybill_split_v3.document_status",
      };

      this.$API.getBillKfTrackRecordListV2(formData).then((res) => {
        if (res.data.status == "success") {
          this.logs = res.data.result.data || [];
          this.logs.map((item) => {
            if (!item.isShowShow) {
              if (item.isShow) {
                item.isShowShow = "是";
              } else {
                item.isShowShow = "否";
              }
            }
          });
        }
      });
    },
    showAddDia() {
      this.isShowDialogTraceCheckIn = true;
      this.addReqs = {
        operationTime: "",
        isShow: 0,
        content: "",
        remarks: "",
        documentStatus: "bill_tms_waybill_split_v3.document_status",
        documentNumber: this.waybillNumber,
        fileIds: [],
      };
    },
    diaConfirmTraceCheckIn() {
      this.submit();
    },
    changeFileList(array) {
      this.fileNameLists = array;
    },
    async submit() {
      this.$API
        .addBillKfTrackRecordV2({
          ...this.addReqs,
          documentNumber: [this.waybillSplitNumber],
          fileIds: this.fileNameLists.map((item) => item.fileId),
        })
        .then((res) => {
          this.$message.success(res.data.message || "提交成功");
          // this.fileNameLists = [];
          // this.fileNames = [];
          this.isShowDialogTraceCheckIn = false;
          this.getData()
        });
    },
  },
};
</script>

<style scoped lang="less">
.trace-check-in-log-container {
  height: 100%;
  display: flex;
  flex-flow: column;
  .glo_dialogForm1 {
    .el-form-item {
      margin-bottom: 5px;
    }
  }
}
</style>